import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

interface StyleProps {
  divider?: boolean;
}

export const useModalTitleStyles = makeStyles(() => ({
  dialogTitle: {
    borderBottom: (props: StyleProps) => (props.divider ? `1px solid ${Colors.lightGray}` : 'none')
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));

export const useModalStyles = makeStyles(() => ({
  loadingOverlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.loadingOverlay,
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0
  },
  placeholderContent: {
    height: '400px'
  },
  modalContent: {
    lineHeight: 1.5
  },
  // Passes the dialog's flex column through, so `DialogContent` scrolls and `DialogActions` stays in view.
  pinnedFooterContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0
  }
}));
